//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/NXObject.js";
let d=[[[0,"BordersAndZones",1,"Drawings.BordersAndZones",0],[0,"Height",0,0],[0,"IsActiveForSketching",0,0],[0,"IsOutOfDate",0,0],[0,"Length",0,0],[0,"ProjectionAngle",0,0],[0,"Units",0,0],[0,"View",0,"View",0]],[[[],"Open",{},0,0],[["num_view"],"GetDraftingViews",{R_:{views:"Drawings.DraftingView[]"}},0,0],[["numerator","denominator"],"GetScale",{},0,0],[["height","length","numerator","denominator","units","projection_angle","num_view","associated_views"],"SetParameters",{},6,0],[[],"ActivateForSketching",{},0,0],[[],"ResetActiveForSketching",{},0,0],[["viewTag"],"GetZoneReference",{R_:{zoneReference:''}},1,0],[["viewTag"],"GetSheetZoneReference",{R_:{sheetZoneReference:''}},1,0],[["sketchCount"],"GetDraftingSketches",{R_:{sketches:"Sketch[]"}},0,0]],[["SheetDraftingViews","Drawings.SheetDraftingViewCollection",0],["SheetSectionLines","Drawings.SheetSectionLineCollection",0]]];
SPLM.Drawings.DrawingSheet = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.DrawingSheet";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.DrawingSheet.Unit = Object.freeze({
    "Inches" : "Inches", "Millimeters" : "Millimeters"});

SPLM.Drawings.DrawingSheet.StandardSheetSize = Object.freeze({
    "A" : "A", "B" : "B", "C" : "C", "D" : "D", "E" : "E", "F" : "F", "H" : "H", "J" : "J", "A0" : "A0", "A1" : "A1", "A2" : "A2", "A3" : "A3", "A4" : "A4"});

SPLM.Drawings.DrawingSheet.ProjectionAngleType = Object.freeze({
    "FirstAngle" : "FirstAngle", "ThirdAngle" : "ThirdAngle"});

export default SPLM;